/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ProductType {
  Unknown = 0,
  Ticket = 10,
  TravelMoney = 20,
  TravelCard = 30,
  OtherWebshopProduct = 90,
}
